module.exports = __webpack_public_path__ + "img/jungle-board.22b86aa6.png";